module.exports = __webpack_public_path__ + "img/know-4.1484e2d5.jpg";